import React, {useState} from 'react'
export default function ABC(){
  const [ABC, setABC] = useState('')
  const [DEF, setDEF] = useState(false)
  const [GHI, setGHI] = useState('')
  const JKL = (e) => {
    e.preventDefault()
    setGHI('')
    var regExScan = new RegExp("^[-@._A-Za-z0-9]{0,10}$")
    if (!(/[A-Za-z]/.test(ABC))){
      setGHI('Input Error. You must contain alphabet.')
    }else if (!(/\d/.test(ABC))){
      setGHI('Input Error. You must contain number.')
    }else if (!regExScan.test(ABC)){
      setGHI('Input Error. Please check your input.')
    }else{
      setDEF(true)
    }
  }
  return (
    <div>
    <form className='flex-col flex w-[200px]' onSubmit={JKL}>
      <label className='text-left text-xs'>Password</label>
      <input type='text' placeholder='pwd-123' className={`w-[120px] text-xs border ${GHI==''?'border-gray-950':'border-red-600'}`} onChange={e=> setABC(e.target.value)} maxlength={10} />
      {/* ▼ user can get error result while typing */}
      { !( /^[-@._A-Za-z0-9-]{0,10}$/.test(ABC))?<span className='error-msg'>Limit 10 char or digit, only "-.@_" is allowed special character.</span>:''}
    <div className='w-[200px] text-left text-xs'>
      password must contains...<br/>
      <span className={`text-[8px] ${ABC.length>0 && ABC.length<11? 'text-[#00712a]' : 'text-[#dcdcdc]'}`}>●</span> max 10 char<br/>
      <span className={`text-[8px] ${(/\d/.test(ABC))? 'text-[#00712a]' : 'text-[#dcdcdc]'}`}>●</span> number<br/>
      <span className={`text-[8px] ${(/[A-Za-z]/.test(ABC))? 'text-[#00712a]' : 'text-[#dcdcdc]'}`}>●</span> alphabet<br/>
      <span className={`text-[8px] ${(/^[-@._A-Za-z0-9]+$/gi.test(ABC)) && (ABC.includes('@')||ABC.includes('-')||ABC.includes('.')||ABC.includes('-'))? 'text-[#00712a]' : 'text-[#dcdcdc]'}`}>●</span> include special character(-@ _.)<br/>
    </div>
    <button className='primary-btn text-xs w-fit mt-1' disabled={!(ABC.length>0)}>Submit</button>
    {GHI==''&&DEF?<div className='text-xs'>You have successfully submited.</div>:<div className='error-msg'>{GHI}</div>}
    </form> 
    </div>
  )
}